import React from "react";
import ReactDOM from "react-dom";
import FileUploadAuthGateModal from "./FileUploadAuthGateModal.jsx";

/**
 * Resolves the File Upload input associated with a click target, whether the
 * click landed on the input itself, on a <label for="..."> pointing at it, or
 * on a <label> that wraps it.
 */
function resolveFileInput(target) {
  if (!target || !target.closest) return null;

  const direct = target.closest('input[type="file"]');
  if (direct) return direct;

  const label = target.closest("label");
  if (!label) return null;

  const forId = label.getAttribute("for");
  if (forId) {
    const byId = document.getElementById(forId);
    if (byId && byId.matches && byId.matches('input[type="file"]')) return byId;
  }
  return label.querySelector('input[type="file"]');
}

/**
 * Gates Sitecore Forms File Upload fields behind authentication. For a file
 * input marked data-forms-auth-required="true" (set server-side when the
 * visitor is not signed in), the native file picker is blocked and a sign-in
 * modal is shown instead. Authenticated users are unaffected. The server also
 * enforces this in the Upload Files to S3 action, so this is UX only.
 *
 * Scope is deliberately limited to the file picker: this never intercepts the
 * submit button or form submission. An anonymous user who does not attach a
 * file is therefore never prompted to sign in and submits the form normally -
 * the sign-in requirement only applies when they try to attach a file.
 */
export function initFileUploadAuthGate() {
  // Mount the modal once.
  if (!document.getElementById("file-upload-auth-gate-root")) {
    const host = document.createElement("div");
    host.id = "file-upload-auth-gate-root";
    document.body.appendChild(host);
    ReactDOM.render(<FileUploadAuthGateModal />, host);
  }

  if (window.__threadFileUploadAuthGateWired) return;
  window.__threadFileUploadAuthGateWired = true;

  // Capture-phase so we intercept before the browser opens the file dialog.
  document.addEventListener(
    "click",
    (e) => {
      const input = resolveFileInput(e.target);
      if (!input || input.getAttribute("data-forms-auth-required") !== "true") {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      const loginUrl = input.getAttribute("data-forms-login-url") || "";
      window.dispatchEvent(
        new CustomEvent("thread:form-auth-gate:open", {
          detail: { loginUrl },
        }),
      );
    },
    true,
  );
}
